<template>
    <div
      v-if="s.popup"
      class="w-3/4 bg-white fixed left-1/2 -translate-x-1/2 z-20 rounded-lg top-4 bottom-4 max-h-screen overflow-hidden max-l:w-11/12 max-l:max-w-11/12"
    >
      <a
        class="flex items-center bg-gray-500 px-4 py-2 absolute top-0 right-0 rounded-close cursor-pointer hover:bg-gray-400 transition-colors duration-150"
        @click="close"
      >
        <span class="text-white mr-2">Закрыть</span>
        <svg class="fill-white w-4 h-4">
          <use xlink:href="@/assets/i.svg#ico-no"></use>
        </svg>
      </a>
      <div class="flex h-full max-l:flex-col">
        <div class="w-1/2 overflow-y-auto max-l:w-full max-l:h-1/2">
          <div class="p-5 v-bbgray">
            <div
              class="flex items-center"
              :class="{
                'status-1': agentMoney.agent_status == 0,
                'status-6': agentMoney.agent_status == 2,
              }"
            >
              <IcoRomb
                :sizes="'w-16 h-16'"
                obj="invoiceMoney"
                :status="agentMoney.status?.toString()"
              />
              <div class="flex flex-col justify-center overflow-hidden pr-8 pl-4">
                <span
                  class="text-[10px] text-gray-400 leading-none uppercase mb-1"
                  >ЗАЯВКА</span
                >
                <span class="font-latobold text-xl">{{
                  agentMoney.id
                }}</span>
                <span class="text-[10px] text-gray-400 leading-none uppercase"
                  >ОТ {{ new Date (agentMoney.created_at).toLocaleDateString() }}</span
                >
              </div>
            </div>
          </div>

          <div class="p-5 v-bbgray flex items-center">
            <div
                class="w-11 h-11 mr-4 rounded-full"
                :class="{
                  'bg-status-1': agentMoney.agent_status == 0,
                  'bg-status-6': agentMoney.agent_status == 2,
                }"
              >
              <div
              class="rounded-full h-11 w-11 bg-green-500 flex items-center justify-center mr-4"
            >
              <svg class="w-5 h-5 fill-white">
                <use xlink:href="@/assets/i.svg#pay-1"></use>
              </svg>
            </div>
            </div>
            <div class="flex flex-col justify-center overflow-hidden pr-8">
              <span class="text-[10px] text-gray-400 leading-none uppercase mb-1"
                >СУММА БОНУСА</span
              >
              <span class="font-latobold text-base">{{ agentMoney.agent_sum + ' ₽' }}</span>
            </div>
          </div>

          <div class="p-5 v-bbgray flex items-center">
            <div
                class="w-11 h-11 mr-4 rounded-full"
                :class="{
                  'bg-status-1': agentMoney.agent_status == 0,
                  'bg-status-6': agentMoney.agent_status == 2,
                }"
              >
                <IcoPic :pic="agentMoney.agent_picture" :name="agentMoney.agent_name" />
            </div>
            <div class="flex flex-col justify-center overflow-hidden pr-8">
              <span class="text-[10px] text-gray-400 leading-none uppercase mb-1"
                >АГЕНТ</span
              >
              <span class="font-latobold text-base">{{ agentMoney.agent_name + " " +  agentMoney.agent_secondname}}</span>
            </div>
          </div>
  
          <div class="p-5 v-bbgray flex items-center">
            <div
              class="rounded-full h-11 w-11 bg-green-500 flex items-center justify-center mr-4"
            >
              <svg class="w-5 h-5 fill-white">
                <use xlink:href="@/assets/i.svg#pay-2"></use>
              </svg>
            </div>
            <div class="flex flex-col justify-center overflow-hidden pr-8">
              <span class="text-[10px] text-gray-400 leading-none uppercase mb-1"
                >ТИП ДОКУМЕНТА</span
              >
              <span class="font-latobold text-base">{{
                agentMoney.agent.payment_method == 1 && "Счет на оплату"
              }}</span>
            </div>
          </div>
  
          <div class="p-5 v-bbgray flex items-center">
            <div
              class="rounded-full h-11 w-11 bg-green-500 flex items-center justify-center mr-4"
            >
              <svg class="w-5 h-5 fill-white">
                <use xlink:href="@/assets/i.svg#pay-2"></use>
              </svg>
            </div>
            <div class="flex flex-col justify-center overflow-hidden pr-8">
              <span class="text-[10px] text-gray-400 leading-none uppercase mb-1"
                >Номер документа для проводки</span
              >
              <span class="font-latobold text-base"
                >{{ agentMoney.agent.value_method}}</span
              >

            </div>
          </div>
  
          <div class="p-5 v-bbgray flex items-center">
            <div
              class="rounded-full h-11 w-11 bg-green-500 flex items-center justify-center mr-4"
            >
              <span class="text-xl uppercase text-white">{{
                agentMoney.client_name?.slice(0, 1)
              }}</span>
            </div>
            <div class="flex flex-col justify-center overflow-hidden pr-8">
              <span class="text-[10px] text-gray-400 leading-none uppercase mb-1"
                >КЛИЕНТ</span
              >
              <span class="font-latobold text-base">{{
                agentMoney.client_name
              }}</span>
            </div>
          </div>
  
          <div class="p-5 v-bbgray flex items-center">
            <div
              class="min-w-[1.5rem] w-11 h-11 rounded-full mr-3 overflow-hidden bg-green-500"
            >
              <IcoPic :pic="agentMoney.manage_picture" :name="agentMoney.manager_name" />
            </div>
            <div class="flex flex-col justify-center overflow-hidden pr-8">
              <span class="text-[10px] text-gray-400 leading-none uppercase mb-1"
                >МЕНЕДЖЕР</span
              >
              <span class="font-latobold text-base"
                >{{ agentMoney.manager_name }} {{ agentMoney.manager_secondname }}</span
              >
            </div>
          </div>
  
          <div class="p-5">
            <div
              v-if="agentMoney.agent_status == 0"
              class="flex items-center max-xl:flex-col max-xl:items-center"
            >
              <Datepicker
                v-model="agentMoney.agent_date"
                format="yyyy-MM-dd HH:mm:ss"
              ></Datepicker>
              <button
                v-if="agentMoney.agent_date"
                class="v-btn bg-green-500 hover:bg-green-400 ml-auto mr-0 max-xl:mt-4 max-xl:mx-0"
                @click="doneAgentMoney(2)"
              >
                <span class="v-btn_text">РАЗНЕСТИ Д/С</span>
              </button>
              <div
                v-else
                class="v-btn bg-gray-500 hover:bg-gray-400 ml-auto mr-0 max-xl:mt-4 max-xl:mx-0"
              >
                <span class="v-btn_text">РАЗНЕСТИ Д/С</span>
              </div>
            </div>
            <div v-else class="flex items-center">
              <div class="flex items-center">
                <div
                  class="rounded-full h-11 w-11 bg-green-500 flex items-center justify-center mr-4"
                >
                  <svg class="w-5 h-5 fill-white">
                    <use xlink:href="@/assets/i.svg#nav-calendar"></use>
                  </svg>
                </div>
                <span class="text-base font-latobold">{{
                  new Date(agentMoney.agent_date).toLocaleString()
                }}</span>
              </div>
              <button
                class="v-btn bg-red-500 hover:bg-red-400 ml-auto mr-4"
                @click="doneAgentMoney(0)"
              >
                <span class="v-btn_text">Отмена</span>
              </button>
            </div>
          </div>
        </div>
  
        <div
          class="px-5 pt-12 pb-6 w-1/2 overflow-y-auto max-l:border-gray-700 max-l:border-t-2 max-l:w-full max-l:h-1/2 max-l:pt-3"
        >
          <CommentList :id="agentMoney.id" type="bid" />
        </div>
      </div>
    </div>
    <div
      v-if="s.popup"
      @click="close"
      class="fixed bg-cyan-900 z-2 w-screen h-screen top-0 left-0 opacity-80"
    ></div>
  
    <div
      id="count"
      class="mb-9 mt-4 grid grid-cols-order__top place-content-center gap-x-14px gap-y-24px"
    >
      <div
        class="relative cursor-pointer text-center uppercase group w-28 h-28 m-auto transition-all duration-300 ease-in-out"
        @click="filterStatus(0)"
      >
        <div
          class="overflow-hidden w-full h-full transition duration-300 ease-in-out"
        >
          <svg
            class="z-2 relative mt-5 w-5 h-5 fill-white mx-auto group-hover:w-6 group-hover:h-6 transition-all duration-300"
          >
            <use xlink:href="@/assets/i.svg#status-1"></use>
          </svg>
          <h2
            class="text-2xl z-2 relative mt-1 text-white group-hover:text-3xl transition-all duration-300"
            v-if="agentMoneyCounter"
          >
            {{ agentMoneyCounter[0] }}
          </h2>
          <svg
            class="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-24 fill-status-1 group-hover:w-full group-hover:h-full transition-all duration-300"
          >
            <use xlink:href="@/assets/i.svg#bg-romb"></use>
          </svg>
        </div>
        <span
          class="duration-300 group-hover:bottom-0 group-hover:opacity-0 absolute left-0 w-full -bottom-4 opacity-100 text-status-20 font-latobold"
          >НОВЫЕ</span
        >
      </div>
      <div
        class="relative cursor-pointer text-center uppercase group w-28 h-28 m-auto transition-all duration-300 ease-in-out"
        @click="filterStatus(2)"
      >
        <div
          class="overflow-hidden w-full h-full transition duration-300 ease-in-out"
        >
          <svg
            class="z-2 relative mt-5 w-5 h-5 fill-white mx-auto group-hover:w-6 group-hover:h-6 transition-all duration-300"
          >
            <use xlink:href="@/assets/i.svg#ico-ok"></use>
          </svg>
          <h2
            class="text-2xl z-2 relative mt-1 text-white group-hover:text-3xl transition-all duration-300"
            v-if="agentMoneyCounter"
          >
            {{ agentMoneyCounter[2] }}
          </h2>
          <svg
            class="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-24 fill-status-6 group-hover:w-full group-hover:h-full transition-all duration-300"
          >
            <use xlink:href="@/assets/i.svg#bg-romb"></use>
          </svg>
        </div>
        <span
          class="duration-300 group-hover:bottom-0 group-hover:opacity-0 absolute left-0 w-full -bottom-4 opacity-100 text-status-20 font-latobold"
          >ОПЛАЧЕНЫ</span
        >
      </div>
    </div>
  
    <div class="px-4 flex flex-wrap mb-8">
      <div class="w-full flex items-center max-xl:flex-wrap max-xl:gap-y-2">
        <h2
          class="mr-15px h-9 min-w-[2.25rem] border border-teal-700 rounded-lg p-2 text-center"
        >
          <span class="w-full text-lg leading-none text-teal-700">{{
            this.agentMoneyList?.length
          }}</span>
        </h2>
  
        <div class="h-9 w-1/4 mr-15px min-w-[180px]">
          <input
            type="text"
            class="w-full px-10px py-8px text-sm bg-slate-50 h-full"
            placeholder="Название"
            v-model="s.findme"
            @input="findAgentMoney(s)"
          />
        </div>
  
        <button
          v-if="s.clear"
          class="mx-0 clear v-btn bg-gray-500 hover:bg-gray-400"
          @click="Clear"
          type="reset"
        >
          <span class="v-btn_text"> Сброс </span>
        </button>
      </div>
    </div>
  
    <div class="flex items-center">
      <select v-model="itemsInPage" style="padding: 7px">
        <option value="10">10</option>
        <option value="20">20</option>
        <option value="50">50</option>
        <option value="100">100</option>
      </select>
      <Paginator :count="pageCount" v-model="page" />
    </div>
  
    <div
      class="w-full bg-white v-bgray2 mb-8 overflow-hidden rounded-xl relative overflow-x-auto"
    >
      <div class="relative h-10 min-w-full">
        <div
          class="grid gap-3 grid-cols-money items-center h-10 v-bbgray px-4 uppercase absolute min-w-full"
        >
          <div
            class="font-latobold cursor-pointer hover:text-green-500 text-gray-400 text-[11px]"
          >
            №
          </div>
          <div
            class="font-latobold cursor-pointer hover:text-green-500 text-gray-400 text-[11px] col-span-2"
          >
            Агент
          </div>
          <div
            class="font-latobold cursor-pointer hover:text-green-500 text-gray-400 text-[11px] col-span-1"
          >
            Менеджер
          </div>
          <div
            class="font-latobold cursor-pointer hover:text-green-500 text-gray-400 text-[11px] ml-6 col-span-2"
          >
            Клиент
          </div>
          <div
            class="font-latobold cursor-pointer hover:text-green-500 text-gray-400 text-[11px]"
          >
          Номер счета в 1C       
          </div>
          <div
            class="font-latobold cursor-pointer hover:text-green-500 text-gray-400 text-[11px]"
          >
          Дата оплаты счета 
          </div>
          <div
            class="font-latobold cursor-pointer hover:text-green-500 text-gray-400 text-[11px] col-span-1"
          >
            Документ на оплату
          </div>
          <div
            class="font-latobold cursor-pointer hover:text-green-500 text-gray-400 text-[11px] text-center"
          >
            Номер документа
          </div>
          <div
            class="font-latobold cursor-pointer hover:text-green-500 text-gray-400 text-[11px] text-right"
          >
            Сумма бонуса
          </div>
        </div>
      </div>
  
      <div v-if="agentMoneyList?.length > 0">
        <template v-for="item in PaginatedAgentMoneyList" :key="item">
          <div
            class="grid gap-3 grid-cols-money px-4 py-2 v-bbgray items-center transition duration-300 cursor-pointer hover:shadow-v1 bg-teal-light odd:bg-white max-2xl:grid-cols-all-mobile max-2xl:auto-rows-[50px]"
            :class="{
              'status-1': item.agent_status == 0,
              'status-6': item.agent_status == 2,
            }"
            @click="showAgentMoney(item), (s.popup = true)"
          >
            <div class="flex">
              <svg
                class="w-5 h-5 mr-4 fill-status-1"
                v-if="item.agent_status == 0"
              >
                <use xlink:href="@/assets/i.svg#status-1"></use>
              </svg>
              <svg
                class="w-5 h-5 mr-4 fill-status-6"
                v-if="item.agent_status == 2"
              >
                <use xlink:href="@/assets/i.svg#status-6"></use>
              </svg>

              {{ item.id }}
            </div>
  
            <div class="flex items-center col-span-2 max-m:col-span-2">
              <div
                class="w-11 h-11 mr-4 rounded-full"
                :class="{
                  'bg-status-1': item.agent_status == 0,
                  'bg-status-6': item.agent_status == 2,
                }"
              >
                <IcoPic :pic="item.agent_picture" :name="item.agent_name" />
              </div>
  
              <div class="flex flex-col justify-center overflow-hidden">
                <span class="text-[10px] text-gray-400 leading-none uppercase"
                  >Агент</span
                >
                <span class="text-base font-semibold">{{ item.agent_name + ' ' + item.agent_secondname}}</span>
              </div>
            </div>
  
            <div class="flex items-center col-span-1 max-m:col-span-1 ">
              <div
                class="w-11 h-11 mr-4 rounded-full"
                :class="{
                  'bg-status-1': item.agent_status == 0,
                  'bg-status-6': item.agent_status == 2,
                }"
              >
                <IcoPic :pic="item.manage_picture" :name="item.manager_name" />
              </div>
  
              <div class="flex flex-col justify-center overflow-hidden">
                <span class="text-[10px] text-gray-400 leading-none uppercase"
                  >Менеджер</span
                >
                <span class="text-base font-semibold">{{ item.manager_name + ' ' + item.manager_secondname}}</span>
              </div>
            </div>

            <div class="flex items-center ml-6 col-span-2 max-m:col-span-1">
            <span
              class="text-white w-11 h-11 mr-4 text-xl leading-none rounded-full flex items-center justify-center min-w-[44px]"
              :class="{
                'bg-status-1': item.agent_status == 0,
                'bg-status-6': item.agent_status == 2,
              }"
              >{{ item.client_name?.slice(0, 1) }}</span
            >
            <div
              class="text-ellipsis overflow-hidden max-h-[44px] whitespace-nowrap pr-8 font-latobold text-base"
            >
              {{ item.client_name }}
            </div>
          </div>

  
            <div v-if="item.codebill" class="">
              {{item.codebill }}
            </div>

            <div v-else class="">
              Номер отсутствует
            </div>
  
            <div v-if="item.agent_date" class="">
              {{ new Date(item.agent_date).toLocaleDateString() }}
            </div>
            <div v-else class="">
              Дата не указана
            </div>
  
            <div class="">
              {{ this.paymentMethod[item.agent.payment_method] }}
            </div>
  
            <div class="text-center">
              {{ item.agent.value_method }}
            </div>
  
            <div class="justify-end text-base font-latobold flex">
              {{ item.agent_sum }} ₽
            </div>
          </div>
        </template>
      </div>
      <div v-else class="mx-auto my-4 flex items-center justify-center">
        <img class="w-11 h-11" src="https://api.tahocrm.ru/images/loader.svg" />
      </div>
    </div>
  </template>
  
  <script>
  import { mapActions, mapGetters } from "vuex";
  // import moment from "moment";
  import Datepicker from "@vuepic/vue-datepicker";
  import "@vuepic/vue-datepicker/dist/main.css";
  import CommentList from "../components/CommentList.vue";
  import IcoPic from "../components/ui/IcoPic.vue";
  import IcoRomb from "../components/ui/IcoRomb.vue";
  import Paginator from "@/components/ui/Paginator";
  
  export default {
    name: "PageAgentMoney",
  
    components: { Datepicker, CommentList, IcoPic, IcoRomb, Paginator },
    data() {
      return {
        page: 0,
        itemsInPage: 10,
        paymentMethod:{
          1: 'Счет на оплату'
        }
      };
    },
  
    computed: {
      ...mapGetters([
        "s",
        "profile",
        "role",
        "roles",
        "agentMoneyList",
        "agentMoney",
        "agentMoneyCounter",
      ]),
      pageCount() {
        return Math.ceil((this.agentMoneyList?.length ?? 0) / this.itemsInPage);
      },
      PaginatedAgentMoneyList() {
        console.log('agentMoneyList', this.agentMoneyList)
        return this.agentMoneyList.slice(
          this.page * this.itemsInPage,
          (this.page + 1) * this.itemsInPage
        );
      },
    },
  
    methods: {
      ...mapActions([
        "getAgentMoneys",
        "findAgentMoney",
        "setAgentMoney",
        "showAgentMoney",
        "doneAgentMoney",
        "clearSettings",
      ]),
  
      filterStatus(status) {
        this.s.status = status;
        this.findAgentMoney(this.s);
      },
  
      Clear() {
        this.clearSettings();
        this.findAgentMoney(this.s);
      },
  
      close() {
        this.s.popup = false;
      },
    },
  
    mounted() {
      console.log('agentMoneyList', this.agentMoneyList)
      this.getAgentMoneys();
      window.DEBUG_MONEY = this;
    },
  };
  </script>
  